'use client';

import { useState } from 'react';
import { Plus, Check } from 'lucide-react';

interface WatchlistButtonProps {
  bookId: string;
  isInWatchlist: boolean;
  onToggle: (bookId: string, added: boolean) => void;
}

export default function WatchlistButton({
  bookId,
  isInWatchlist,
  onToggle,
}: WatchlistButtonProps) {
  const [loading, setLoading] = useState(false);
  const [inList, setInList] = useState(isInWatchlist);

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (inList) {
        // Remove from watchlist
        const res = await fetch(`/api/watchlist?bookId=${bookId}`, {
          method: 'DELETE',
        });
        if (res.ok) {
          setInList(false);
          onToggle(bookId, false);
        }
      } else {
        // Add to watchlist
        const res = await fetch('/api/watchlist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ bookId }),
        });
        if (res.ok) {
          setInList(true);
          onToggle(bookId, true);
        }
      }
    } catch (error) {
      console.error('Watchlist toggle error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      title={inList ? 'Remove from Watchlist' : 'Add to Watchlist'}
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '2px solid white',
        background: inList ? 'white' : 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: loading ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        opacity: loading ? 0.5 : 1,
      }}
      onMouseEnter={(e) => {
        if (!loading) {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.background = inList ? 'white' : 'rgba(255, 255, 255, 0.9)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.background = inList ? 'white' : 'rgba(0, 0, 0, 0.5)';
      }}
    >
      {inList ? (
        <Check size={20} color="#667eea" strokeWidth={3} />
      ) : (
        <Plus size={20} color="white" strokeWidth={3} />
      )}
    </button>
  );
}

